/* DJI Power — mega menu.
 *
 * Opens on hover and on keyboard focus, closes on header mouseleave, Escape,
 * or navigation. Durations are NOT duplicated here: the retract length is read
 * off the element's own computed style, so brand/components.css stays the one
 * place a timing is written down.
 *
 * The top-level items are anchors, not buttons. Without this script they still
 * navigate, which is the whole reason they are anchors — the menu is an
 * enhancement layered on four working links, not a replacement for them.
 */
(function () {
  'use strict';

  var header = document.querySelector('.dp-header');
  if (!header) return;

  var tops = Array.prototype.slice.call(header.querySelectorAll('[data-dp-menu]'));
  var panels = Array.prototype.slice.call(header.querySelectorAll('[data-dp-panel]'));
  if (!tops.length || !panels.length) return;

  /* The drawer's breakpoint, from components.css. Above it the panels open;
     below it the <details> drawer owns the menu and these never fire. */
  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var closeTimer = null, exitTimer = null, openKey = null;

  function ms(el, prop) {
    var v = getComputedStyle(el)[prop] || '0s';
    v = v.split(',')[0].trim();
    return v.indexOf('ms') > -1 ? parseFloat(v) : parseFloat(v) * 1000;
  }

  function show(key) {
    if (!DESKTOP.matches || openKey === key) return;
    clearTimeout(closeTimer);
    /* An exit already in flight would otherwise hide the panel we just
       reopened, via a timer fired after this function returns. */
    clearTimeout(exitTimer);
    panels.forEach(function (p) { p.classList.remove('is-closing'); });
    panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-dp-panel') !== key;
    });
    tops.forEach(function (a) {
      a.setAttribute('aria-expanded',
        a.getAttribute('data-dp-menu') === key ? 'true' : 'false');
    });
    header.classList.add('is-menuopen');
    openKey = key;
  }

  function settle() {
    panels.forEach(function (p) {
      p.hidden = true;
      p.classList.remove('is-closing');
      /* the next open staggers in again */
      var w = p.querySelector('.dp-menupanes');
      if (w) w.classList.remove('is-switched');
    });
  }

  function hide() {
    if (openKey === null) return;
    var live = panels.filter(function (p) { return !p.hidden; });
    tops.forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
    header.classList.remove('is-menuopen');
    openKey = null;
    if (!live.length) return;
    live.forEach(function (p) { p.classList.add('is-closing'); });
    clearTimeout(exitTimer);
    exitTimer = setTimeout(settle, ms(live[0], 'animationDuration') || 300);
  }

  tops.forEach(function (a) {
    var key = a.getAttribute('data-dp-menu');
    a.setAttribute('aria-expanded', 'false');
    a.addEventListener('mouseenter', function () { show(key); });
    a.addEventListener('focus', function () { show(key); });
    /* Touch: there is no hover, so the first tap opens and the second follows
       the link. Without this a tap navigates before the panel is ever seen. */
    a.addEventListener('click', function (e) {
      if (!DESKTOP.matches) return;
      if (window.matchMedia('(hover: hover)').matches) return;
      if (openKey !== key) { e.preventDefault(); show(key); }
    });
  });

  panels.forEach(function (p) {
    p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
  });

  /* A short grace period: the pointer crosses a few pixels of header between
     the bar item and the panel below it, and closing on that gap makes the
     menu feel like it is running away. */
  header.addEventListener('mouseleave', function () {
    closeTimer = setTimeout(hide, 120);
  });
  header.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || openKey === null) return;
    var focused = document.querySelector('[data-dp-menu][aria-expanded="true"]');
    hide();
    if (focused) focused.focus();
  });

  /* Tabbing out of the header entirely closes the menu — otherwise a keyboard
     user leaves an open panel behind them covering the page. */
  document.addEventListener('focusin', function (e) {
    if (openKey !== null && !header.contains(e.target)) hide();
  });

  DESKTOP.addEventListener('change', function (e) { if (!e.matches) { hide(); settle(); } });

  
  panels.forEach(function (panel) {
    var tabs = Array.prototype.slice.call(panel.querySelectorAll('[data-dp-menutab]'));
    var panes = Array.prototype.slice.call(panel.querySelectorAll('[data-dp-menupane]'));
    if (!tabs.length) return;
    var wrap = panel.querySelector('.dp-menupanes');
    function pick(tab) {
      var id = tab.getAttribute('data-dp-menutab');
      if (tab.getAttribute('aria-selected') === 'true') return;
      if (wrap) wrap.classList.add('is-switched');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panes.forEach(function (p) {
        p.classList.toggle('is-on', p.getAttribute('data-dp-menupane') === id);
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { pick(tab); });
      tab.addEventListener('mouseenter', function () { pick(tab); });
      tab.addEventListener('focus', function () { pick(tab); });
      tab.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        tabs[(i + step + tabs.length) % tabs.length].focus();
      });
    });
  });
}());
